import React, { useState, useEffect, useContext} from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import CloseIcon from "@material-ui/icons/Close";
import Divider from "@material-ui/core/Divider";
import useStyles from "../styles";
import Card from "@material-ui/core/Card";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MyDailogModal from "../../../Commons/myDailogModal"; //DragDropInput,
import FileCopyIcon from "@material-ui/icons/FileCopy";
import CardContent from "@material-ui/core/CardContent";
import FlightDetails from "../../../AgentWebsite/Flights/flightDetails";
import {
  amountINSFormat,
  WebContext,
  copyToClipWithFormating,
  isEmptyObject,
  getUTCDate,
} from "../../../../Utility";
import { StyledTypographyBlack } from "../../../Commons/styledTabs";
import { useTheme } from "@material-ui/core/styles";

const Overview = ({
  bookingData = {},
  itineraryData = {},
}) => {
  const theme = useTheme();

  const classes = useStyles();
  const {
    setViewSnackbar,
    deskTopView = false,
    memberProfile = {},
  } = useContext(WebContext);
  const {
    created_at = "",
    final_b2c_amount = "",
    pnr = "",
    status = null,
    itinerary_detail = {},
  } = bookingData;

  const {
    origin = "",
    destination = "",
    departure_at = "",
    item_code,
  } = itinerary_detail;

  const itemCode = item_code === undefined ? "" : item_code;

  const [flightDetailStatus, setFlightDetailStatus] = useState(false);
  const [flightDetailStatusInt, setFlightDetailStatusInt] = useState(false);
  const [fareRules, setFareRules] = useState([]);
  const { meta_data: { itineraryItems = [] } = {} } = itineraryData || {};
  const [isIntReturn, setIsIntReturn] = useState(false);
  const [flightBookingDetail, setFlightBookingDetail] = useState({
    departDetail: {},
    arrivalDetail: {},
  });
  const { account = {} } = memberProfile;
  const { lms_organisation_code: orgCode = null } = account;

  useEffect(() => {
    if (itineraryItems.length == 0) return;
    itineraryItems.forEach((item) => {
      if (item.itemFlight) {
        const { itemFlight, itemCode: myItemCode } = item;
        const {
          isRefundable = "",
          journeyType = "",
          isDomestic = "",
        } = itemFlight;

        if (journeyType == 2 && isDomestic == false) {
          setIsIntReturn(true);
        }
        if (itemCode == myItemCode) {
          const { fareRule } = itemFlight;
          const { fareQuote } = itemFlight;
          const {
            currency: cr,
            finalFare: fF,
            resultIndex: rI,
          } = fareQuote || {};
          const { segments = [] } = itemFlight;
          const [departFlight = [], arrivalFlight = []] = segments || [];

          setFareRules(fareRule);
          const departFlightObj = {
            sg: [...departFlight] || [],
            cr: cr || "",
            fF: fF || "",
            rI: rI || "",
            iR: isRefundable || "",
          };

          let arrivalFlightObj = {};

          if (arrivalFlight.length > 0) {
            arrivalFlightObj = {
              sg: [...arrivalFlight] || [],
              cr: cr || "",
              fF: fF || "",
              rI: rI || "",
              iR: isRefundable || "",
            };
          }
          setFlightBookingDetail({
            ...flightBookingDetail,
            departDetail: departFlightObj,
            arrivalDetail: arrivalFlightObj,
          });
        }
      }
    });
  }, [itineraryItems]);

  let title = `${origin} - ${destination}`;

  let bookingStatusObj = {
    success: {
      label: "Booking Confirmed",
      color: theme?.agentTheme?.success?.main,
    },
    pending: { label: "Booking Pending", color: "#FBAD23" },
    cancellation_initiated: {
      label: "Booking Cancellation Initiated",
      color: "#FBAD23",
    },
    cancellation_settled: {
      label: "Booking Cancellation Settled",
      color: "#FBAD23",
    },
    cancelled: {
      label: "Booking Cancelled",
      color: theme?.agentTheme?.destructive?.main,
    },
    failed: { label: "Booking Failed", color: "#828282" },
    hold: { label: "On Hold", color: "#FBAD23" },
    released: { label: "Booking Released", color: "#828282" },
  };

  const GetBookingStatus = ({ status = null }) => {
    if (!status) return null;
    let labelText =
      bookingStatusObj[status] && bookingStatusObj[status]["label"];
    let color = bookingStatusObj[status] && bookingStatusObj[status]["color"];
    return (
      <Typography
        variant="subtitle1"
        style={{ color: color, fontSize: "14px" }}
      >
        {labelText}
      </Typography>
    );
  };

  const TravelOn = () => {
    return (
      <Box>
        <span
          className={classes.textGrayOne}
          style={{
            display: "inline-block",
            marginBottom: "4px",
            color: theme?.agentTheme?.text?.light,
          }}
        >
          {"Travel On"}
        </span>
        <br />
        {getUTCDate(departure_at) || ""}
      </Box>
    );
  };

  const BookedOn = () => {
    return (
      <Box>
        <span
          className={classes.textGrayOne}
          style={{
            display: "inline-block",
            marginBottom: "4px",
            color: theme?.agentTheme?.text?.light,
          }}
        >
          {"Booked On"}
        </span>
        <br />
        {getUTCDate(created_at) || ""}
      </Box>
    );
  };

  const DateAndPnr = ({ status = "" }) => {
    const failedBooking = status == "failed";
    return (
      <Box display="flex" mt={2} justifyContent={"space-between"}>
        <div className={classes.upperSpaceDiv}>
          <div className={classes.dateDiv}>
            <Box display={deskTopView && "flex"}>
              <Box pr={3} mb={!deskTopView && 2}>
                <Typography
                  variant="body2"
                  style={{
                    fontSize: "14px",
                    color: theme?.agentTheme?.card?.foreground,
                  }}
                >
                  {deskTopView ? <BookedOn /> : !failedBooking && <TravelOn />}
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="body2"
                  style={{ color: theme?.agentTheme?.card?.foreground }}
                >
                  {deskTopView ? !failedBooking && <TravelOn /> : <BookedOn />}
                </Typography>
              </Box>
            </Box>
          </div>
        </div>
        {pnr && pnr.length > 0 && (
          <div className={classes.upperSpaceDiv} textAlign="right">
            <Box display="flex" alignItems="center" mt={0.5}>
              <FileCopyIcon
                style={{
                  fontSize: "22px",
                  cursor: "pointer",
                  color: theme?.agentTheme?.primary?.main,
                }}
                onClick={() =>
                  copyToClipWithFormating("pnrNumber", () =>
                    setViewSnackbar({ message: "PNR Copied!", type: "success" })
                  )
                }
              />
              &nbsp;
              <span
                className={`${classes.boldText}`}
                style={{
                  fontSize: "14px",
                  color: theme?.agentTheme?.card?.foreground,
                }}
              >
                PNR:
              </span>
              &nbsp;
              <Typography
                variant="subtitle1"
                id="pnrNumber"
                className={classes.fontSizeLess}
                style={{
                  fontSize: "14px",
                  color: theme?.agentTheme?.card?.foreground,
                }}
              >
                {pnr}
              </Typography>
            </Box>
          </div>
        )}
      </Box>
    );
  };


  const BookingBarFlight = ({ type = "", from = "", to = "" }) => {
    return (
      <Box>
        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon style={{ color: "black" }} />}
          >
            <Typography
              style={{ color: "black" }}
              variant={"h6"}
            >{`Booking Details (${from} - ${to})`}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails
            style={{ display: "flex", flexDirection: "column" }}
          >
            {flightBookingDetail.arrivalDetail && (
              <FlightDetails
                flightDetail={
                  type == "departure"
                    ? flightBookingDetail.departDetail
                    : flightBookingDetail.arrivalDetail
                }
                isIntReturn={isIntReturn}
                showModal={false}
                deskTopView={deskTopView}
                fareRules={fareRules}
              />
            )}
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </Box>
    );
  };

  const ShowIntReturnModal = () => {
    return (
      <MyDailogModal
        titleText={
          <Box display={"flex"} justifyContent={"space-between"}>
            <StyledTypographyBlack variant="h6">
              Booking Details
            </StyledTypographyBlack>{" "}
            <CloseIcon
              onClick={() => {
                setFlightDetailStatusInt(false);
              }}
            />
          </Box>
        }
        bodyText={
          <>
            <Box mb={2}>
              <BookingBarFlight
                type="departure"
                from={origin}
                to={destination}
              />
            </Box>
            <Box mt={2}>
              <BookingBarFlight type="arrival" from={destination} to={origin} />
            </Box>
          </>
        }
        actions={[]}
        openDailog={true}
        onClose={() => setFlightDetailStatusInt(false)}
        showCloseButton={true}
        showDivider={true}
        fullScreen={deskTopView ? false : true}
        maxWidth={"md"}
      />
    );
  };

  return (
    <>
      <Card className={classes.paddedCards}>
        <CardContent style={{ paddingTop: "12px" }}>
          <Box
            mb={1}
            display="flex"
            justifyContent="space-between"
            width="100%"
            alignItems={"center"}
          >
            <Typography variant="subtitle1" className={classes.overviewText}>
              Overview
            </Typography>
            {bookingData && !isEmptyObject(bookingData) && (
              <Typography
                className={`${classes.viewDetails}`}
                onClick={() =>
                  isIntReturn
                    ? setFlightDetailStatusInt(true)
                    : setFlightDetailStatus(true)
                }
              >
                View Details
              </Typography>
            )}
          </Box>
          <Divider />
          <Box display="flex" justifyContent="space-between" mt={2}>
            <Box>
              <Box pr={1}>
                <Typography
                  style={{
                    fontSize: "24px",
                    color: theme?.agentTheme?.card?.foreground,
                    fontWeight: 500,
                  }}
                >
                  {title}
                </Typography>
                <GetBookingStatus status={status} />
              </Box>
            </Box>
            <Typography
              variant="h6"
              style={{
                fontSize: "20px",
                color: theme?.agentTheme?.card?.foreground,
              }}
            >
              INR {amountINSFormat(final_b2c_amount) || ""}
            </Typography>
          </Box>
          <DateAndPnr status={status} />
        </CardContent>
        {flightDetailStatus && (
          <FlightDetails
            flightDetail={flightBookingDetail["departDetail"]}
            orgCode={orgCode}
            fareRules={fareRules}
            onClose={() => setFlightDetailStatus(false)}
            isIntReturn={isIntReturn}
            deskTopView={deskTopView}
          />
        )}
        {flightDetailStatusInt && <ShowIntReturnModal />}
      </Card>
    </>
  );
};

export default Overview;
